import React, { Suspense } from 'react';

const LoadableComponent = React.lazy(() => import('./Workspaces'));

function LoadableWorkspaces() {
  return (
    <Suspense fallback={<div />}>
      <LoadableComponent />
    </Suspense>
  );
}

export default LoadableWorkspaces;
